import { CommonModule } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FlexLayoutModule } from 'ngx-flexible-layout';
//import { ConfigService } from 'libs/abc/core/configuration/src/lib/services/config.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DataService } from '@barthauer/abc/core/data';
import { BceService } from '@barthauer/abc/management/configuration-explorer';
import {
  _AbcCheckBoxComponent,
  AbcDateBoxComponent,
  AbcDropDownBoxComponent,
  AbcTextBoxComponent,
  AbcUiComponentsModule,
} from '@barthauer/abc/ui-components';
import { AbcUiObjectSelectionModule } from '@barthauer/abc/ui-frameworks/object-selection';
import { DxLoadIndicatorModule } from 'devextreme-angular';
import { CreateWorksWizardComponent } from './create-works-wizard.component';
import { ConfigurationComponent } from './pages/configuration/configuration.component';
import { WorkService } from './services/work.service';

import { _AbcGridComponent } from '@barthauer/abc/ui-components';

@NgModule({
  declarations: [CreateWorksWizardComponent, ConfigurationComponent],
  exports: [CreateWorksWizardComponent],
  imports: [
    CommonModule,
    MatStepperModule,
    MatIconModule,
    MatRadioModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MatButtonModule,
    BrowserAnimationsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatSelectModule,
    MatToolbarModule,
    AbcUiComponentsModule,
    MatProgressBarModule,
    MatDatepickerModule,
    AbcUiObjectSelectionModule,
    DxLoadIndicatorModule,
    _AbcGridComponent,
    AbcTextBoxComponent,
    AbcDropDownBoxComponent,
    AbcDateBoxComponent,
    _AbcCheckBoxComponent,
  ],
  providers: [DataService, BceService, HttpClient, WorkService, provideHttpClient(withInterceptorsFromDi())],
})
export class CreateWorksWizardModule {}
